import React from 'react';
import PropTypes from 'prop-types';
import styles from './HeaderAndFooter.module.css';
import { Footer, Header } from '../../components';

const HeaderAndFooter = ({ children,openClose,displayDrawer}) => (
  <div className={styles.body}>
    <Header openClosee={openClose} displayDrawer={displayDrawer}/>
    <div className={styles.renderArea}>{children}</div>
    <Footer />
  </div>
);

HeaderAndFooter.propTypes = {
  children: PropTypes.any,
  openClose: PropTypes.func,
  displayDrawer: PropTypes.any,
};

export default HeaderAndFooter;
